import React from 'react';
import BreadCrumbsContainer from 'src/components/10-atoms/BreadCrumbs/Container';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import { getEPBreadCrumbs } from './getBreadCrumbs';
const EPBreadCrumbs = ({ ancestorsDetails, knownNodes, visibleCount, ...breadCrumbsContainerProps }) => {
    const [{ theme }] = useTheme();
    const crumbs = getEPBreadCrumbs(ancestorsDetails, knownNodes, { visibleCount });
    return (React.createElement(BreadCrumbsContainer, { ph: theme.spacing.page, crumbs: crumbs, visibleCount: visibleCount, ...breadCrumbsContainerProps }));
};
export default EPBreadCrumbs;
